export default {"src":"/_next/static/media/green_star.b1d8d86e.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};